import React from 'react';
import { useTrack } from './useTrack';

interface TrackViewProps {
  tip: string;
}
const TrackView: React.FC<TrackViewProps> = ({ tip, children }) => {
  const track = useTrack();
  React.useEffect(() => {
    track('view', {
      tip,
    });
  }, [track, tip]);

  return <>{children}</>;
};

export default TrackView;
